








































import Vue from 'vue';
import { VBTooltip, BTable } from 'bootstrap-vue';
import LoadingSpinner from '@reciprocity/loading-spinner';
import EditColumn from '@/components/zen_components/zen_object_table/edit_column/EditColumn.vue';

interface Column {
  key: string;
  class: string;
}

export default Vue.extend({
  name: 'ZenObjectTable',
  components: {
    BTable,
    LoadingSpinner,
    EditColumn,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array as () => (string | Column)[],
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    columnsWithClass(): Column[] {
      return this.columns.map(column => {
        if (typeof column === 'string') {
          return {
            key: column,
            class: `${column}-col`,
          };
        } else {
          column.class = `${column.key}-col`;
          return column;
        }
      });
    },
  },
});
